import { Stack, Text, Button, Group, ThemeIcon, Badge, Card, Title, Divider } from '@/components/ui';
import { IconCheck, IconSparkles, IconHistory, IconInfoCircle } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useAiWorkflowStore } from '../../../../stores/aiWorkflowStore';

export default function WorkflowComplete() {
  const navigate = useNavigate();
  const {
    activeSessionId,
    selectedPresetName,
    targetRecordType,
    reset,
  } = useAiWorkflowStore();

  const handleStartAnother = () => {
    reset();
  };

  const handleViewSessions = () => {
    reset();
    navigate('/app/ai/sessions');
  };

  return (
    <Stack gap="lg">
      {/* Success card with green accent */}
      <Card
        shadow="sm"
        padding="lg"
        radius="md"
        withBorder
        style={{ borderLeft: '4px solid var(--mantine-color-green-6)' }}
      >
        <Stack align="center" gap="lg" py="md">
          <ThemeIcon size={64} radius="xl" color="green" variant="light">
            <IconCheck size={36} />
          </ThemeIcon>

          <Stack align="center" gap="xs">
            <Text fw={600} size="xl">Record Created Successfully</Text>
            <Text size="sm" c="dimmed">
              Your {targetRecordType} record has been created using the &quot;{selectedPresetName}&quot; preset.
            </Text>
          </Stack>
        </Stack>
      </Card>

      {/* Details card with session info */}
      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Group justify="space-between" mb="sm">
          <Group gap="xs">
            <IconInfoCircle size={20} />
            <Title order={4}>Session Details</Title>
          </Group>
        </Group>
        <Divider mb="sm" />
        <Stack gap="sm">
          <Group gap="md">
            <Text size="sm" fw={500}>Preset Used:</Text>
            <Text size="sm">{selectedPresetName}</Text>
          </Group>
          <Group gap="md">
            <Text size="sm" fw={500}>Record Type:</Text>
            <Badge variant="light" color="blue">{targetRecordType}</Badge>
          </Group>
          {activeSessionId && (
            <Group gap="md">
              <Text size="sm" fw={500}>Session ID:</Text>
              <Badge variant="light" color="gray" size="lg">
                {activeSessionId}
              </Badge>
            </Group>
          )}
          <Group gap="md">
            <Text size="sm" fw={500}>Status:</Text>
            <Badge variant="light" color="green">Completed</Badge>
          </Group>
        </Stack>
      </Card>

      {/* Action buttons */}
      <Group justify="center" mt="md">
        <Button
          variant="default"
          leftSection={<IconHistory size={16} />}
          onClick={handleViewSessions}
        >
          View Sessions
        </Button>
        <Button
          leftSection={<IconSparkles size={16} />}
          onClick={handleStartAnother}
        >
          Start Another
        </Button>
      </Group>
    </Stack>
  );
}
